import PropTypes from 'prop-types';
import style from './Checkbox.module.css';

function Checkbox({ id, value, checked, onChange, className = '', required = false }) {
  return (
    <input
      type="checkbox"
      id={id}
      value={value}
      checked={checked}
      onChange={onChange}
      required={required}
      className={`${style.checkbox} appearance-none h-4 w-4 border border-dark-warm-grey dd-kr:border-actual-dd-gold dd-en:border-actual-dd-gold dd-kr:rounded dd-en:rounded bg-transparent checked:bg-acacia checked:border-none checked:dd-kr:bg-actual-dd-gold checked:dd-en:bg-actual-dd-gold focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left cursor-pointer ${className}`}
    />
  );
}

Checkbox.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
  ]),
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  required: PropTypes.bool,
};


export default Checkbox;
